import axios from '../config/axiosConfig'

export const getMisDocumentos = (id) => {
  const documentosQuery = `?pacienteId=${id}`
  return axios.get(`/documentos${documentosQuery}`).then(response => response.data)
}
